import type { FileByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetFileByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetFileByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetFileByIdArgs = {
  id: string;
};

export const useGetFileById = createQueryHook<
  UseGetFileByIdArgs,
  FileByIdResponseRow[],
  GetFileByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.files.getById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ file_by_pk: data[0] ?? null }),
  graphqlDocument: GetFileByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
